import { useRequiredContext } from "@redotech/react-util/context";
import TagIcon from "@redotech/redo-icons/tag-01.svg";
import TagFilledIcon from "@redotech/redo-icons/tag-01_filled.svg";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { ImsPermissions } from "@redotech/redo-model/permissions";
import { LinkPrimaryTab } from "@redotech/redo-web/arbiter-components/navigation/primary/redo-primary-nav";
import { PageNavigationEntry } from "@redotech/redo-web/arbiter-components/navigation/redo-side-navigation";
import { SecondaryNavigationData } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav";
import { useNavTreeNode } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { InventoryManagementSuiteStatusesContext } from "../../../../redo-suite/inventory-cloud";
import { InventoryItem } from "./inventory";

export function useInventoryNavigation(): PageNavigationEntry | null {
  const routes = useRequiredContext(MerchantRoutesContext);

  const pathRoot = routes.inventoryManagementBaseUrl;

  const { imsEnabled } = useRequiredContext(
    InventoryManagementSuiteStatusesContext,
  );

  const canViewInventoryManagement = useHasPermission(
    ...Object.values(ImsPermissions),
  );

  if (!canViewInventoryManagement) {
    return null;
  }

  const href = routes.getInventoryHref({ enabled: imsEnabled });

  const primaryTab: LinkPrimaryTab = {
    id: "inventory",
    hasNotification: false,
    UnfilledIcon: TagIcon,
    FilledIcon: TagFilledIcon,
    type: "link",
    pathRoot,
    href,
    friendlyName: "Inventory management",
  };

  const secondaryNavigationData: SecondaryNavigationData = {
    id: "inventory",
    name: "Inventory management",
    NavContent: InventorySecondaryNavigation,
  };

  return { primaryTab, secondaryNavigationData };
}

const InventorySecondaryNavigation = memo(
  function InventorySecondaryNavigation() {
    const { id: nodeId, TreeContext } = useNavTreeNode({
      friendlyName: "Inventory management",
    });

    return (
      <TreeContext.Provider value={nodeId}>
        <InventoryItem />
      </TreeContext.Provider>
    );
  },
);
